/**
 * クライアント側 crypto の定数。
 *
 * サーバ側 (apps/api/src/crypto/crypto.constants.ts) と
 * **必ず同じ値** を保つこと。鍵階層全体は KEY_HIERARCHY.md §5 を単一ソースとする。
 */

// ── Argon2id (RFC 9106 First Recommendation) ───────────────────
export const ARGON2 = {
  DEFAULT_MEMORY_KIB: 65536, // 64 MiB
  DEFAULT_TIME_COST: 3,
  DEFAULT_PARALLELISM: 4,
  DEFAULT_OUTPUT_BYTES: 32, // 256 bit
  DEFAULT_SALT_BYTES: 16, // 128 bit
} as const

// ── AES-256-GCM (NIST SP 800-38D) ──────────────────────────────
export const AES_GCM = {
  KEY_BYTES: 32,
  IV_BYTES: 12, // 96-bit IV (GCM 推奨)
  AUTH_TAG_BYTES: 16, // 128-bit tag
  AUTH_TAG_BITS: 128,
} as const

// ── HKDF (NIST SP 800-56C) ─────────────────────────────────────
export const HKDF = {
  HASH: 'SHA-256' as const,

  /** SMK_enc を派生する際の info パラメータ */
  INFO_SMK_ENC: 'ookey/v1/smk-enc' as const,

  /** SMK_mac を派生する際の info パラメータ */
  INFO_SMK_MAC: 'ookey/v1/smk-mac' as const,

  /** Recovery KEK 派生用 info (T-C5b、KEY_HIERARCHY.md §4.7) */
  INFO_RECOVERY_KEK: 'OoKey/recovery/kek/v1' as const,

  /** Recovery Verifier 派生用 info (T-C5b、KEY_HIERARCHY.md §4.7) */
  INFO_RECOVERY_VERIFY: 'OoKey/recovery/verify/v1' as const,
} as const

// ── Recovery Key (T-C5b、KEY_HIERARCHY.md §4.7) ────────────────
export const RECOVERY = {
  /** HKDF salt 長 (16 byte = 128 bit) */
  KDF_SALT_BYTES: 16,

  /** KEK_recovery / Recovery Verifier の HKDF 出力長 (32 byte = 256 bit) */
  HKDF_OUTPUT_BYTES: 32,

  /** Recovery KDF 仕様バージョン (forward-compat 用) */
  KDF_VERSION: 1,
} as const
